import {html, LitElement} from '@isceco/widget-library2/external/lit'
import VerticalNavigationCss from './AdminVerticalNavigationCss.js'
import '@isceco/widget-library2/basic-elements/Link/Link.js'

export class AdminVerticalNavigation extends LitElement {

  static get styles() {
    return [VerticalNavigationCss]
  }

  static get properties() {
    return {
      items: {type: Array}
    }
  }

  constructor() {
    super()
    this.items = []
  }

  render() {
    return html`
      <style>
        @import '${iscecoWidgetLibrary.iconCss}'
      </style>
      <nav>
        <button class="hamburger-menu"
                title=" "
                @click="${() => this._triggerMobileMenu()}">
          <i class="bars icon"></i>
        </button>
        <div class="desktop">
          ${this.items.map(item => this._renderLink(item))}
        </div>
        <div class="mobile">
          <div>
            ${this.items.map(item => this._renderLink(item))}
          </div>
        </div>
      </nav>
    `
  }

  _triggerMobileMenu = () => {
    const mobileDIV = this.shadowRoot.querySelector('.mobile > div')
    const hamburgerMenu = this.shadowRoot.querySelector('.hamburger-menu > i')
    mobileDIV.classList.toggle('show')
    if (mobileDIV.classList.contains('show')) {
      hamburgerMenu.className = 'close icon'
    } else {
      hamburgerMenu.className = 'bars icon'
    }
  }

  _renderLink = item => {
    const icon = item.icon ? html`<i class="icon ${item.icon}"></i>` : ''
    if(item.placeholder) {
      return html`
          <div class="placeholder-item">
            ${icon}
            ${item.text}
          </div>
      `
    }
    if (item.callback) {
      return html`
        <isceco-link class="${item.submenu ? 'sub-menu' : ''}" @click="${() => this._executeCallback(item)}">
          <div class="navigation-item  ${this._getActive(item)}">
            ${icon}
            ${item.text}
          </div>
        </isceco-link>
      `
    } else {
      return html`
        <isceco-link class="${item.submenu ? 'sub-menu' : ''}" url="${item.url}" @click="${_ => this._hideMobileMenu()}">
          <div class="navigation-item ${this._getActive(item)}">
            ${icon}
            ${item.text}
          </div>
        </isceco-link>
      `
    }
  }

  _executeCallback = item => {
    this._hideMobileMenu()
    item.callback(item)
  }

  _hideMobileMenu = () => {
    const mobileDisplay = this.shadowRoot.querySelector('.mobile')
    if (getComputedStyle(mobileDisplay).display !== 'none') {
      this._triggerMobileMenu()
    }
  }

  _getActive = item => {
    if (getNavigationHash() === '' && item.active) {
      return 'active'
    }
    if (item.suburls !== undefined
      && item.suburls.length !== null
      && item.suburls.indexOf(getNavigationHash()) >= 0) {
      return 'active'
    }
    return item.url === getNavigationHash() ? 'active' : ''
  }
}

customElements.define('gasmonitoring-admin-vertical-navigation', AdminVerticalNavigation)
